import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { EmptyState } from "../../../shared/components/EmptyState";

export const WorkflowStep7List = ({ stats }: any) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="row">
        <div className="col-6">
          <div className="card">
            <div className="card-header pb-0">
              <div className="d-flex justify-content-start">
                <h4 className="card-title mg-b-0">
                  {t("workflow.copywriters")}
                </h4>
              </div>
            </div>
            <div className="card-body">
              {stats?.copywriters?.length === 0 ? (
                <EmptyState />
              ) : (
                <div className="table-responsive">
                  <Table className="align-middle table-nowrap mb-0 table table-bordered border-dark ">
                    <thead className="table-light">
                      <tr>
                        <th scope="col" rowSpan={2}>{`${t("global.id")}`}</th>
                        <th scope="col text-center" rowSpan={2}>{`${t(
                          "global.name"
                        )}`}</th>
                        <th scope="col" colSpan={2}>{`Base data`}</th>
                        <th scope="col" colSpan={2}>{`Attributes`}</th>
                        <th scope="col" colSpan={2}>{`Copywriting`}</th>
                      </tr>
                      <tr>
                        <th scope="col">{`${t("global.done")}`}</th>
                        {true && (
                          <th scope="col">{`${t("global.inprogress")}`}</th>
                        )}

                        {/* <th scope="col">{`${t("global.total")}`}</th> */}
                        <th scope="col">{`${t("global.done")}`}</th>
                        {true && (
                          <th scope="col">{`${t("global.inprogress")}`}</th>
                        )}
                        <th scope="col">{`${t("global.done")}`}</th>
                        {true && (
                          <th scope="col">{`${t("global.inprogress")}`}</th>
                        )}

                        {/* <th scope="col">{`${t("global.total")}`}</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {stats?.copywriters?.map((user: any) => {
                        return (
                          <tr>
                            <td>{user.id}</td>
                            <td>
                              {user?.user?.firstName +
                                " " +
                                user?.user?.lastName}
                            </td>
                            <td>
                              {user?.baseData?.done +
                                user?.baseData?.inProgress}
                            </td>

                            <td>{user?.baseData?.inProgress}</td>

                            <td>
                              {user?.attributes?.done +
                                user?.attributes?.inProgress}
                            </td>

                            <td>{user?.attributes?.inProgress}</td>

                            <td>
                              {user?.content?.done + user?.content?.inProgress}
                            </td>

                            <td>{user?.content?.inProgress}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="card">
            <div className="card-header pb-0">
              <div className="d-flex justify-content-start">
                <h4 className="card-title mg-b-0">
                  {t("workflow.translators")}
                </h4>
              </div>
            </div>
            <div className="card-body">
              {stats?.translatorsData?.length === 0 ? (
                <EmptyState />
              ) : (
                <div className="table-responsive">
                  <Table className="align-middle table-nowrap mb-0">
                    <thead className="table-light">
                      <tr>
                        <th scope="col">{`${t("global.name")}`}</th>
                        <th scope="col">{`${t("global.inprogress")}`}</th>
                        <th scope="col">{`${t("global.done")}`}</th>
                        <th scope="col">{`${t("global.total")}`}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stats?.translatorsData?.map((user: any) => {
                        return (
                          <tr>
                            <td>{user.firstName + " " + user.lastName}</td>
                            <td>{user.isNotDone}</td>
                            <td>{user.isDone}</td>
                            <td>{user.total}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
